import{a as m}from"./chunk-6XDWEJQU.mjs";import{b as e}from"./chunk-TN4M2PHH.mjs";import{h as o,i as r}from"./chunk-2JBE4HP3.mjs";var i=new o({locale:[m,e,r]});export{i as a};
